import axios from 'axios';
import { BACKEND_API_URL } from '../constants';

/**
 * API para gerenciar envio de formulários SAC/Contato
 */

/**
 * Envia formulário de contato/SAC
 * @param {Object} dados - Dados do formulário
 * @returns {Promise<Object>} Resposta do servidor
 */
export const enviarFormularioContato = async (dados) => {
  try {
    const response = await axios.post(`${BACKEND_API_URL}/api/sac/contato`, dados, {
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: false
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao enviar formulário de contato:', error);
    throw error;
  }
};

